<template>
  <div class="generalstaff">
    <Hero
      :backImg="require('../assets/img/generalstaff/hero.jpg')"
      :backImgSp="require('../assets/img/generalstaff/hero_sp.jpg')"
      alt=""
      title="事業所採用"
      titleSub="実務推進職系（一般職）"
      text=""
    />
    <div class="contents">
      <dl class="column01">
        <dt>業務内容</dt>
        <dd>
          <dl>
            <dt>1. 設備設計・管理</dt>
            <dd>自社開発プラントを構成する機器、装置の設計、メンテナンス</dd>
            <dd>
              プラント内にある様々な機械や電気、計装設備（プラントを制御するための測定・制御装置）の設計やメンテナンスを行い、プラントの安全・安定な稼働を支える。また、新たな機器・装置の増設・更新・撤去等の施工管理や、それらが仕様通りに動作するかを確認する検収までも行い、安全・安定・高品質な製品の製造を実現させる。
            </dd>
          </dl>
          <dl>
            <dt>2. 製造</dt>
            <dd>
              安全かつ安定的なプラント運転を実現し、高品質な製品を作り出す
            </dd>
            <dd>
              365日・24時間連続で稼働する化学プラントおよび発電プラント内にある、様々な機械や装置を運転・制御し、顧客の要求する品質を満たす製品を安全かつ安定的に製造する。プラントの稼動状況から異常の早期発見に努めるとともに、生産工程の課題に対する改善提案を行い、プラントの安全性・効率性を高めていく。
            </dd>
          </dl>
          <dl>
            <dt>3. 分析評価</dt>
            <dd>分析・評価技術を用いた研究開発業務へのサポート</dd>
            <dd>
              既存製品の改良や新製品・新技術の開発への支援、環境・安全を確保するための分析・評価を行い、スペシャリティ製品・技術の改良や開発を支える。社内には分析・評価に特化した研究室もあり、基礎的な分析に加え、高度な分析への要求に対してもそれに適合した分析方法を設計する。
            </dd>
          </dl>
        </dd>
      </dl>
      <dl class="column02">
        <dt>募集要項</dt>
        <dd>
          <dl>
            <dt>募集職種</dt>
            <dd>
              <p class="supplement">
                ※エントリーご希望の方はページ下部お問合せ先へご連絡ください
              </p>
              <p class="job-cat">設備設計・管理職</p>
              <dl>
                <dt>募集学科・専攻</dt>
                <dd>
                  機械、電気、電子系専攻<br />
                  国公立、私立大学および大学院、高等専門学校、専門学校
                </dd>
              </dl>
              <dl>
                <dt>勤務時間</dt>
                <dd>
                  〈いわき地区〉 8:30～17:00（休憩45分間）<br />
                  〈茨城地区〉 9:00〜17:30（休憩45分間）<br />
                  ＊フレックスタイム制あり
                </dd>
              </dl>
              <dl class="last">
                <dt>職務内容</dt>
                <dd>
                  <p>• 電気、計装、機械などの設備の設計、メンテナンス</p>
                  <p>• 製造設備の施工管理</p>
                </dd>
              </dl>
              <p class="job-cat">製造職</p>
              <dl>
                <dt>募集学科・専攻</dt>
                <dd>
                  機械、電気、電子、化学、情報システム系専攻<br />
                  国公立、私立大学および大学院、高等専門学校、専門学校
                </dd>
              </dl>
              <dl>
                <dt>勤務時間</dt>
                <dd>
                  7:45～15:00（1勤）<br />
                  14:45～23:00 （2勤）<br />
                  22:45～8:00 （3勤）<br />
                  ＊いずれも休憩75分間
                </dd>
              </dl>
              <dl class="last">
                <dt>職務内容</dt>
                <dd>
                  <p>• 製造プラント、発電プラントの運転管理</p>
                  <p>• 生産工程の課題に対する企画立案</p>
                </dd>
              </dl>
              <p class="job-cat">分析評価職</p>
              <dl>
                <dt>募集学科・専攻</dt>
                <dd>
                  化学系専攻<br />
                  国公立、私立大学および大学院、高等専門学校、専門学校
                </dd>
              </dl>
              <dl>
                <dt>勤務時間</dt>
                <dd>
                  〈いわき地区〉 8:30～17:00（休憩45分間）<br />
                  〈茨城地区〉 9:00〜17:30（休憩45分間）<br />
                  ＊フレックスタイム制あり
                </dd>
              </dl>
              <dl class="last">
                <dt>職務内容</dt>
                <dd>各種製品や開発品に関する分析・評価</dd>
              </dl>
            </dd>
            <dt>募集予定人数</dt>
            <dd>
              <p>15～20名</p>
            </dd>
            <dt>選考内容</dt>
            <dd>
              <p>書類選考、適性検査、面接 など</p>
            </dd>
            <dt>初任給</dt>
            <dd>
              学部卒：192,000円<br />
              高専卒：192,000円（専攻科）<br />
              高専卒：183,000円（本科）
              <p class="supplement">※2022年度実績、基本給のみ</p>
            </dd>
            <dt>昇給・賞与</dt>
            <dd>昇給年1回・賞与年2回</dd>
            <dt>勤務地</dt>
            <dd>
              いわき事業所（福島県いわき市）または樹脂加工事業所（茨城県小美玉市）
              <p class="supplement">※将来的には転勤の可能性あり</p>
            </dd>
            <dt>勤務時間</dt>
            <dd>
              ＜休日＞<br />
              日
              勤：週休2日制（土・日）、祝日、年末年始など、年間休日数123日（2022年実績）<br />
              三交替：年間休日数110日（交替勤務カレンダーに基づく）<br />
              ＜休暇・休業＞
              <p>
                ・年次有給休暇（初年度14日、以降1年ごとに1日ずつ加算し、最高は20日）
              </p>
              <p>
                ・その他、時間単位有給休暇（日勤者のみ取得可能）・転勤休暇・慶弔休暇・生理休暇・育児休業・介護休業
                など
              </p>
            </dd>
            <dt>教育・研修</dt>
            <dd>
              新入社員教育、OJT、役割別研修、海外・国内留学制度、応募型研修、<br />
              論文審査制度、語学教育、 各種学会・講習会派遣 など
            </dd>
            <dt>お問い合わせ</dt>
            <dd>
              〒974-8686 福島県いわき市錦町落合16<br />
              労政部 採用担当
              <p class="supplement mb-1em">
                オンライン形式の個別会社説明会を随時承っております。ご希望の場合はお気軽にお問い合わせください。
              </p>
              <a href="tel:0246634457" class="tel">
                <img
                  src="../assets/img/common/contact/iwaki_chokutu_tel.png"
                  style="max-height: 40px"
                /> </a
              ><br />
              <a v-on:click="mail_to_iwaki('', '')" class="mail">
                <img
                  src="../assets/img/common/contact/iwaki_mail.png"
                  style="max-height: 40px"
                />
              </a>
            </dd>
          </dl>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
export default {
  components: {
    Hero,
  },
  methods: {
    converter: function (M) {
      var str = '',
        str_as = '';
      for (var i = 0; i < M.length; i++) {
        str_as = M.charCodeAt(i);
        str += String.fromCharCode(str_as + 1);
      }
      return str;
    },
    mail_to_iwaki(k_1, k_2) {
      eval(
        String.fromCharCode(
          108,
          111,
          99,
          97,
          116,
          105,
          111,
          110,
          46,
          104,
          114,
          101,
          102,
          32,
          61,
          32,
          39,
          109,
          97,
          105,
          108,
          116,
          111,
          58
        ) +
          escape(k_1) +
          this.converter(
            String.fromCharCode(
              114,
              96,
              104,
              120,
              110,
              116,
              44,
              106,
              113,
              104,
              63,
              106,
              116,
              113,
              100,
              103,
              96,
              45,
              98,
              110,
              45,
              105,
              111,
              62,
              114,
              116,
              97,
              105,
              100,
              98,
              115,
              60
            )
          ) +
          escape(k_2) +
          "'"
      );
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .page-title br:first-child {
  display: block;
}
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 100px 0 150px;
  @media print, screen and (max-width: 767px) {
    padding: 100px 0;
  }
  dd {
    margin: 0;
  }
  & > dl > dt {
    font-weight: bold;
    font-size: 30px;
    text-align: center;
    @media print, screen and (max-width: 767px) {
      font-size: 34px;
    }
  }
}

.column01 {
  font-weight: bold;
  margin-bottom: 120px;
  & > dd {
    & > dl {
      border: 2px solid #3fa600;
      border-radius: 6px;
      margin-top: 40px;
      @media print, screen and (min-width: 768px) {
        padding: 35px 80px 45px 80px;
      }
      @media print, screen and (max-width: 767px) {
        padding: 35px 25px 45px 25px;
      }
      & > dt {
        color: #3fa600;
        font-size: 22px;
        text-align: center;
        & + dd {
          margin: 10px 0;
          font-size: 18px;
          text-align: center;
        }
      }
      dd {
        text-align: justify;
        text-justify: inter-ideograph; //IE対応
      }
    }
  }
}

.column02 {
  & > dd {
    & > dl {
      margin: 30px 0 0 0;
      border-top: 2px solid #3fa600;
      display: flex;
      flex-wrap: wrap;
      @media print, screen and (max-width: 767px) {
        flex-direction: column;
      }
      & > dt {
        padding: 30px 0 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 22px;
        @media print, screen and (min-width: 768px) {
          width: 260px;
          border-bottom: 2px solid #3fa600;
          padding: 30px 0;
        }
      }
      & > dd {
        padding: 30px 0;
        margin: 0;
        border-bottom: 2px solid #3fa600;
        font-size: 18px;
        font-weight: bold;
        margin: 0;
        @media print, screen and (min-width: 768px) {
          width: calc(100% - 260px);
        }
        @media print, screen and (max-width: 767px) {
          font-size: 16px;
        }
        p {
          line-height: 1.5em;
          margin: 0;
          text-indent: -1em;
          margin-left: 1em;
          &.supplement {
            font-size: 15px;
            font-weight: normal;
            text-indent: 0;
            margin-left: 0;
            & + p {
              margin-top: 10px;
            }

            &.mb-1em {
              margin-bottom: 1rem;
            }
          }
        }
        & > .job-cat {
          background-color: #3fae00;
          color: #fff;
          font-size: 18px;
          text-align: center;
          margin: 0;
          margin-top: 30px;
          position: relative;
          border-radius: 5px 5px 0 0;
          &:after {
            content: '';
            width: 0;
            height: 0;
            border: 7px solid transparent;
            border-top: 7px solid #3fae00;
            position: absolute;
            bottom: -14px;
            left: 0;
            right: 0;
            margin: auto;
          }
        }
        & > dl {
          display: flex;
          // align-items: center;
          flex-wrap: wrap;
          // background-color: #3fab0029;
          background-color: rgba(63, 171, 0, 0.16);
          margin: 0;
          padding: 0 10px;
          &.last {
            & > dt,
            & > dd {
              border-bottom: 0;
            }
          }
          & > dt {
            color: #3fae00;
            font-size: 18px;
            width: 200px;
            padding: 30px 0;
            line-height: 1.5em;
            border-bottom: 2px solid #3fae00;
            @media print, screen and (max-width: 767px) {
              width: 30%;
            }
          }
          & > dd {
            margin: 0;
            width: calc(100% - 200px);
            font-size: 15px;
            font-weight: bold;
            line-height: 1.5em;
            padding: 30px 0;
            border-bottom: 2px solid #3fae00;
            p {
              line-height: 1.5em;
              margin: 0;
              text-indent: -0.7em;
              margin-left: 0.7em;
            }
            @media print, screen and (max-width: 767px) {
              width: calc(100% - 30%);
            }
          }
        }
        .tel,
        .mail {
          img {
            margin-top: 5px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
